import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { message } from 'antd';
import * as Actions from "./../containers/qr/actions";
import * as C from './../containers/qr/constants';
import QrList from './../components/qr.table';


const mapStateToProps = state => ({
    answer: state.QrReducer,
});

const mapDispatchProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

class QrController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            formLoading: false,
            list: [],
            filter: '',
            sort: '-createdAt',
            total: 0,
            page: 0,
            limit: 0,
        };
    }


    updateFilter = (value) => {
        this.setState({
            page: 0,
            filter: value,
        }, () => {
            this.props.actions.LoadList(this.state.page, this.state.filter, this.state.sort);
        });
    };

    updateSort = (sort) => {
        this.setState({
            sort: sort,
            page: 0,
        }, () => {
            this.props.actions.LoadList(this.state.page, this.state.filter, this.state.sort);
        });
    };

    changePage = (page) => {
        this.setState({ page }, () => {
            this.props.actions.LoadList(this.state.page, this.state.filter, this.state.sort);
        });
    };

    componentDidMount() {
        this.props.actions.LoadList(this.state.page, this.state.filter, this.state.sort);
    }

    componentWillReceiveProps(p) {
        if (p.answer && p.answer.state) {
            switch (p.answer.state) {
                case C.QR_LOAD_START:
                case C.QR_DELETE_START:
                case C.QR_UPDATE_START:
                    this.setState({
                        isLoading: true,
                        formLoading: false,
                    });
                    break;
                case C.QR_LOAD_FINISH:
                    const data = p.answer.data && p.answer.data.data ? p.answer.data.data : {};
                    this.setState({
                        isLoading: false,
                        formLoading: false,
                        list: data.list || [],
                        total: data.total || 0,
                        limit: data.limit || 0,
                    });
                    break;
                case C.QR_LOAD_ERROR:
                    this.setState({
                        isLoading: false,
                        formLoading: false,
                    });
                    message.error(`Error load qr list`);
                    break;

                case C.QR_CREATE_START:
                    this.setState({formLoading: true});
                    break;
                case C.QR_CREATE_ERROR:
                    this.setState({formLoading: false});
                    message.error(`Error create qr code`);
                    break;
                case C.QR_CREATE_FINISH:
                    message.success(`Qr has been created`);
                    this.props.actions.LoadList(this.state.page, this.state.filter, this.state.sort);
                    break;
                case C.QR_DELETE_ERROR:
                    this.setState({formLoading: false, isLoading: false});
                    message.error(`Error delete qr code`);
                    break;
                case C.QR_DELETE_FINISH:
                    message.success(`Qr has been deleted`);
                    this.props.actions.LoadList(this.state.page, this.state.filter, this.state.sort);
                    break;
                case C.QR_UPDATE_FINISH:
                    message.success(`Qr has been updated`);
                    this.props.actions.LoadList(this.state.page, this.state.filter, this.state.sort);
                    break;
                case C.QR_UPDATE_ERROR:
                    this.setState({formLoading: false, isLoading: false});
                    message.error(`Error update qr code`);
                    break;
                default: break;
            }
        }
    }

    onCreate = (data) => {
        this.props.actions.CreateQr(data);
    };

    onUpdateItems = (item_id = '', data = {}) => {
        this.props.actions.UpdateQr(item_id, data);
    };

    onDeleteItem = (item_id) => {
        this.props.actions.DeleteQr(item_id);
    };


    render() {
        return (
            <React.Fragment>
                <QrList
                    page={this.state.page}
                    total={this.state.total}
                    limit={this.state.limit}
                    list={this.state.list}
                    loading={this.state.isLoading}
                    updateFilter={this.updateFilter}
                    updateSort={this.updateSort}
                    updatePage={this.changePage}
                    onUpdate={this.onUpdateItems}
                    onDelete={this.onDeleteItem}
                    onCreate={this.onCreate}
                />
            </React.Fragment>
        )
    }
}


QrController.propTypes = {
    actions: PropTypes.instanceOf(Object).isRequired,
    answer: PropTypes.instanceOf(Object).isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchProps
)(QrController);



// WEBPACK FOOTER //
// ./src/controllers/Qr.controller.js